import React from "react";
import { ScenarioElementPlaybackState } from "../../../../uiModel/playback/ScenarioElementPlaybackState";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { MenuButtonComponent } from "../common/MenuButtonComponent";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";
import { PauseIcon, PlayIcon, ReplayIcon } from "../../../icons";

interface Props {
  playbackState: ScenarioElementPlaybackState;
  onPlay: () => void;
  onPause: () => void;
  onReplay: () => void;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
  className?: string;
}

export const PlaybackControlComponent: React.FC<Props> = ({
  playbackState,
  onPlay,
  onPause,
  onReplay,
  onCancelTooltip,
  onRequestTooltip,
  className,
}) => {
  if (playbackState === "elementFinished") {
    return (
      <MenuButtonWithTooltipComponent
        isDisabled={true}
        icon={<PlayIcon />}
        onClick={() => {}}
        className={className}
        tooltipTarget="playbackControl"
        onCancelTooltip={onCancelTooltip}
        onRequestTooltip={onRequestTooltip}
      />
    );
  }

  let icon: React.ReactNode;
  let onClick: () => void;

  switch (playbackState) {
    case "scenarioFinished":
      icon = <ReplayIcon />;
      onClick = onReplay;
      break;
    case "paused":
    case "looping":
    case "seekingAfterPause":
      icon = <PlayIcon />;
      onClick = onPlay;
      break;
    case "playing":
    case "seekingAfterPlay":
      icon = <PauseIcon />;
      onClick = onPause;
      break;
    default:
      throw new Error(`Unrecognized playbackState '${playbackState}'`);
  }
  return (
    <MenuButtonWithTooltipComponent
      icon={icon}
      onClick={onClick}
      className={className}
      tooltipTarget="playbackControl"
      onCancelTooltip={onCancelTooltip}
      onRequestTooltip={onRequestTooltip}
    />
  );
};
